import React from 'react';

import { Translation, Button, Link } from '../../common';

import {
  OFFLINE_SEPA_VALUE,
  INSTALLMENT_VALUE,
  IDEAL_INSTALLMENT_VALUE,
  PAY_LATER_VALUE,
  SEPA_DIRECT_DEBIT_VALUE,
} from '../../../constants/payment';
import { MAKE_BANK_TRANSFER } from '../../../constants/api';

import styles from './index.module.scss';

export default ({
  methodName,
  methodValue,
  onPayNow,
  token,
  disabled,
  payNowLabel,
}) => (
  <div className={styles['pay-now__wrapper']}>
    <div className={styles['pay-now__chosen-type']}>
      <Translation inline>CHECKOUT_BOTTOM_PAYMENT_METHOD</Translation>
      <Translation inline>{methodName}</Translation>
    </div>
    {methodValue === OFFLINE_SEPA_VALUE ? (
      <Link
        raw
        id="page.payments.component.payment-now.pay-now-link"
        to={MAKE_BANK_TRANSFER(token)}
      >
        <Button
          id="page.payments.component.payment-now.pay-now-button"
          className={styles['pay-now__button']}
          disabled={!methodValue}
          fullwidth
        >
          <Translation>SEPA_PAYMENT_BUTTON_TEXT</Translation>
        </Button>
      </Link>
    ) : methodValue === INSTALLMENT_VALUE ? (
      <span></span>
    ) : methodValue === SEPA_DIRECT_DEBIT_VALUE ? (
      <Button
        id="page.payments.component.payment-now.pay-now-button"
        className={styles['pay-now__button']}
        onClick={onPayNow}
        disabled={disabled}
        fullwidth
      >
        <Translation>SEPA_DEBIT_PAYMENT_BUTTON_TEXT</Translation>
      </Button>
    ) : (
      <Button
        id="page.payments.component.payment-now.pay-now-button"
        className={styles['pay-now__button']}
        onClick={onPayNow}
        disabled={disabled || !methodValue}
        fullwidth
      >
        {payNowLabel}
      </Button>
    )}
  </div>
);
